/**
 * Controle de Acesso Page - Epic 27
 * Refactored to use extracted hook and components
 *
 * Página principal para gestão de permissões e controle de acesso
 * Acesso: Apenas MASTER
 */
import { Sidebar } from '../components/Sidebar';
import { MainLayout } from '../components/MainLayout';
import { useControleAcesso } from '../hooks/useControleAcesso';
import {
  MatrizPermissoesView,
  PermissoesUsuarioView,
  AcessoLoadingState,
  AcessoErrorState,
  AcessoHeader,
} from '../components/controle-acesso';

export const ControleAcessoPage = () => {
  const {
    // Tab state
    activeTab,
    handleTabChange,

    // Loading states
    isLoading,
    error,
    loadingUsuario,

    // Matrix data
    matriz,
    perfis,
    handlePermissaoChange,

    // User data
    usuarios,
    selectedUsuario,
    permissoesUsuario,
    handleSelectUsuario,
    handleUsuarioPermissaoChange,

    // Actions
    loadData,
  } = useControleAcesso();

  if (isLoading) {
    return (
      <>
        <Sidebar />
        <MainLayout className="flex items-center justify-center">
          <AcessoLoadingState />
        </MainLayout>
      </>
    );
  }

  if (error) {
    return (
      <>
        <Sidebar />
        <MainLayout className="flex items-center justify-center">
          <AcessoErrorState error={error} onRetry={loadData} />
        </MainLayout>
      </>
    );
  }

  return (
    <>
      <Sidebar />
      <MainLayout>
        <div className="p-6">
          <AcessoHeader
            activeTab={activeTab}
            onTabChange={handleTabChange}
          />

          {/* Content */}
          {activeTab === 'matriz' ? (
            <MatrizPermissoesView
              matriz={matriz!}
              perfis={perfis}
              onPermissaoChange={handlePermissaoChange}
            />
          ) : (
            <PermissoesUsuarioView
              usuarios={usuarios}
              selectedUsuario={selectedUsuario}
              permissoesUsuario={permissoesUsuario}
              loadingUsuario={loadingUsuario}
              onSelectUsuario={handleSelectUsuario}
              onPermissaoChange={handleUsuarioPermissaoChange}
            />
          )}
        </div>
      </MainLayout>
    </>
  );
};
